import intl from 'react-intl-universal';
import { useState, useEffect, forwardRef } from 'react';
import { isFunction } from 'lodash';
import { Pagination, Empty } from 'antd';

import style from './index.less';

interface Props {
    data: any[];
    key?: string;
    children: React.ReactNode | ((data: any) => React.ReactNode);
    listTilte: React.ReactNode | ((data: any) => React.ReactNode);
    pageNum?: number;
    pageSize?: number;
    total?: number;
    hasPagination?: boolean;
    changePagination?: (pageNum: number) => void;
    onExpandChange?: (
        params: any,
        isExpand?: boolean,
        isFirst?: boolean,
    ) => void;
    showItem?: number;
    isClick?: boolean;
}

const List: React.FC<Props> = forwardRef((props, ref) => {
    const {
        data: originData,
        listTilte,
        children,
        key = 'id',
        pageNum,
        pageSize = 10,
        total,
        hasPagination = true,
        showItem = 0,
        onExpandChange,
    } = props;

    const [data, setData] = useState<any[]>(originData);

    useEffect(() => {
        if (originData && originData.length) {
            initData(originData);
        } else {
            setData([]);
        }
    }, [originData]);

    const initData = (originData: any[]) => {
        if (!hasPagination || (hasPagination && pageNum === 1)) {
            originData?.forEach((item: any, index: number) => {
                if (showItem) {
                    if (item?.after_sale_no === showItem) {
                        item.isExpand = true;
                        return item;
                    }
                } else {
                    if (index === 0) {
                        item.isExpand = true;
                        return item;
                    }
                }
            });
            onExpandChange &&
                onExpandChange(originData[0], originData[0]?.isExpand, true);
        }
        setData(originData);
    };

    const onTitleClick = (currentItem: any) => {
        onExpandChange && onExpandChange(currentItem, currentItem.isExpand);
        setData(
            data?.map((item) => ({
                ...item,
                isExpand:
                    currentItem[key] === item[key]
                        ? !currentItem.isExpand
                        : false,
            })),
        );
    };

    const changePagination = (e: any) => {
        props.changePagination?.(e);
    };

    return (
        <div
            className={style.listContianer}
            ref={ref}
        >
            {data?.map((item: any) => (
                <div
                    key={item[key]}
                    className={style.listItem}
                >
                    <div
                        className={style.itemTitle}
                        onClick={() => onTitleClick(item)}
                    >
                        {isFunction(listTilte) ? listTilte(item) : listTilte}
                    </div>
                    {item.isExpand && (
                        <div className={style.itemContent}>
                            {isFunction(children) ? children(item) : children}
                        </div>
                    )}
                </div>
            ))}
            {data?.length ? (
                hasPagination && (
                    <div className={style.pageContainer}>
                        <Pagination
                            current={pageNum}
                            total={total}
                            pageSize={pageSize}
                            onChange={(e) => changePagination(e)}
                            showSizeChanger={false}
                        />

                        <div className={style.total}>
                            {intl.get('总共')}
                            {total}
                            {intl.get('条')}
                        </div>
                    </div>
                )
            ) : (
                <Empty description={intl.get('暂无数据')} />
            )}
        </div>
    );
});

export default List;
